import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-create-field-dialog',
  templateUrl: './create-field-dialog.component.html',
  styleUrls: ['./create-field-dialog.component.scss']
})
export class CreateFieldDialogComponent implements OnInit {
  types = ['text', 'date', 'radio', 'file', 'textarea', 'dropdown', 'label'];
  alignments = ['left', 'center', 'right'];
  field = {
    title: '',
    value: '',
    alignment: this.alignments[0],
    type: this.types[0],
    options: [],
    isRequired: false
  };
  options: [] = [];

  constructor(public dialogRef: MatDialogRef<CreateFieldDialogComponent>) {
  }

  ngOnInit(): void {
  }

  close(data?: any) {
    this.dialogRef.close(data);
  }

  create(): void {
    const data = this.createField();
    this.close(data);
  }

  createField(): any {
    return {
      type: this.field.type,
      label: this.field.title,
      value: this.field.value,
      options: this.field.options,
      isRequired: this.field.isRequired
    };
  }
}
